<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Kanban components'
 * Name: 'Tasks Kanban Card'
 * FIGMA: 'https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=14488-36483&m=dev'
 */
import type { TasksKanbanCardProps } from '../types/interfaces'

import { AppBadge } from '@shared/ui/badges'

import { useTasksKanbanCard } from '../composables/tasks-kanban-card.hook'
import TasksKanbanCardHeader from './TasksKanbanCardHeader.vue'
import TasksKanbanCardCustomer from './TasksKanbanCardCustomer.vue'
import TasksKanbanCardAgent from './TasksKanbanCardAgent.vue'

defineOptions({
  name: 'TasksKanbanCard',
})

const props = withDefaults(defineProps<TasksKanbanCardProps>(), {
  priority: null,
  priorityLabel: '',
  customerName: null,
  kidName: null,
  discipline: null,
  disciplineUrl: null,
  relatedToType: null,
  subscriptionId: null,
  subscriptionUrl: null,
  agentName: null,
  deadline: null,
  expired: false,
  upcoming: false,
  isGo: false,
  customerBrand: null,
})

const emit = defineEmits<{
  click: [taskId: number]
}>()

const {
  refShowPriority,
  refPriorityColor,
  handleClick,
} = useTasksKanbanCard({
  props,
  onClick: (taskId: number) => emit('click', taskId),
})
</script>

<template>
  <div class="task-card__wrapper">
    <NuxtLink
      :class="['task-card', { expired, upcoming }]"
      :to="taskUrl"
      @click="handleClick"
    >
      <AppBadge
        v-if="refShowPriority"
        class="task-card__priority"
        :color="refPriorityColor"
        :text="priorityLabel"
      />
      <TasksKanbanCardHeader
        :task-id="taskId"
        :task-name="taskName"
      />
      <div class="task-card__info">
        <TasksKanbanCardCustomer
          :customer-name="customerName"
          :kid-name="kidName"
          :discipline="discipline"
          :discipline-url="disciplineUrl"
          :related-to-type="relatedToType"
          :subscription-id="subscriptionId"
          :subscription-url="subscriptionUrl"
          :is-go="isGo"
          :customer-brand="customerBrand"
        />
        <TasksKanbanCardAgent
          :agent-name="agentName"
          :deadline="deadline"
          :expired="expired"
          :upcoming="upcoming"
        />
      </div>
    </NuxtLink>
  </div>
</template>

<style lang="scss" scoped src="../styles/_tasks-kanban-card.scss" />
